/**
 * TanStack Query hooks for `budget-pacing-alerts`.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	list,
	upsert,
	budgetPacingAlertsQueryKeys,
	type BudgetPacingAlertsListFilters,
	type ListBudgetPacingAlertsResponse,
	type UpsertBudgetPacingAlertBody,
	type UpsertBudgetPacingAlertResponse,
} from "./api";

export function useBudgetPacingAlertsList(
	filters: BudgetPacingAlertsListFilters = {},
): UseQueryResult<ListBudgetPacingAlertsResponse, Error> {
	return useQuery({
		queryKey: budgetPacingAlertsQueryKeys.list(filters),
		queryFn: () => list(filters),
	});
}

export function useBudgetPacingAlertsUpsert(): UseMutationResult<
	UpsertBudgetPacingAlertResponse,
	Error,
	UpsertBudgetPacingAlertBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: upsert,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: budgetPacingAlertsQueryKeys.all });
		},
	});
}
